import CryptoJS from 'crypto-js'
import storage from './storageSelector'

const key = CryptoJS.enc.Utf8.parse('8080808080808080')
const iv = CryptoJS.enc.Utf8.parse('8080808080808080')

const option = {
  keySize: 128 / 8,
  iv: iv,
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7
}

export default class StorageService {
  constructor() {
    this.option = option
    this.items = {}
  }

  _decrypt(value) {
    if (!value || value == null) return ''

    const decrypted = CryptoJS.AES.decrypt(value, key, this.option)
    let result = decrypted.toString(CryptoJS.enc.Utf8)
    let obj

    try {
      obj = JSON.parse(result)
    } catch (ex) {
      obj = result
    }

    try {
      if (typeof result == 'object') {
        result = eval(obj)
        if (result == undefined) {
          //ie
          result = obj
        }
      } else {
        result = obj
      }
    } catch (e) {
      result = obj
    }

    return result
  }

  _encrypt(value) {
    const text = JSON.stringify(value)
    const encryptedlogin = CryptoJS.AES.encrypt(text, key, this.option)
    return encryptedlogin.toString()
  }

  getItem(key) {
    if (key && key.length) {
      if (this.keyIsExpired(key)) {
        this.removeItem(key)
      }

      if (this.items[key]) {
        return this.items[key]
      } else {
        const value = storage.getItem(key)
        let decrypted = null

        if (value !== null) {
          decrypted = this._decrypt(value)
          this.items[key] = decrypted
        }

        return decrypted
      }
    } else {
      throw new Error('invalid key')
    }
  }

  getItemEncrypted(key) {
    if (key && key.length) {
      if (this.keyIsExpired(key)) {
        this.removeItem(key)
      }

      return storage.getItem(key)
    } else {
      throw new Error('invalid key')
    }
  }

  setItem(key, value, ttl) {
    if (value !== '') {
      const encrypted = this._encrypt(value)

      if (ttl) {
        ttl = Math.abs(ttl)
        var now = Date.now()
        var schedule = now + ttl * 1000
        storage.setItem(key + '_expiresIn', schedule)
      }

      storage.setItem(key, encrypted)
    }
  }

  removeItem(key) {
    if (typeof this.items[key] != 'undefined') {
      delete this.items[key]
      delete this.items[key + '_expiresIn']
    }

    storage.removeItem(key)
    storage.removeItem(key + '_expiresIn')
  }

  removeAllItemsByPrefix(keyPrefix) {
    if (typeof keyPrefix !== 'undefined') {
      const arr = []
      for (let i = 0; i < storage.length; i++) {
        if (storage.key(i).indexOf(keyPrefix) == 0) {
          arr.push(storage.key(i))
        }
      }
      for (let i = 0; i < arr.length; i++) {
        this.removeItem(arr[i])
      }
    }
  }

  clear() {
    for (var key in storage) {
      if (key.indexOf('_expiresIn') === -1) {
        this.removeItem(key)
      }
    }
  }

  clearAll() {
    this.items = {}
    storage.clear()
  }

  length() {
    return typeof storage.length === 'function'
      ? storage.length()
      : storage.length
  }

  keyIsExpired(key) {
    var ttlKey = key + '_expiresIn'
    var ttlValue = storage.getItem(ttlKey) || 0
    return ttlValue && Date.now() > ttlValue
  }
}



// WEBPACK FOOTER //
// ./~/@octadesk/storage/src/storageService.js